import React, { useEffect, useMemo, useState } from "react";
import SearchComponent from "../../components/search";
import Table from '../../components/datatable/datatable';
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Dropdown from "../../components/dropdown";
import { adminDeleteApplication, adminFetchAllApplications, deleteApplication } from "../../core/axios/endpoints";
import Papa from "papaparse";
import Swal from "sweetalert2";
import { RoutesFullPath } from "../../utils/constants";
import PartnerInvoiceBuilderModal from "../../components/partner-invoice-builder";
import { PartnerBadge, partnerInvoiceCandidateFromRows } from "../../core/partner-subsidie";

const AdminEIAAanvragenPage = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [SelectedRows, setSeletedRows] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [statistics, setStatistics] = useState({
        totalApplications: 0,
        totalAmount: 0,
    });

    const navigate = useNavigate();

    const handleViewClick = (record) => {
        navigate(`${RoutesFullPath.aanvraagDetailsEIAAdmin}/${record?._id}`, {
            state: { admin: true }
        });
    };

    const [activeSegment, setActiveSegment] = useState('new');
    // Partner-filters (subsidie via partner-link, zie AGENTS.md 3.28).
    const [partnerOnly, setPartnerOnly] = useState(false);
    const [toInvoiceOnly, setToInvoiceOnly] = useState(false);
    const [invoiceBuilderOpen, setInvoiceBuilderOpen] = useState(false);
    const [actionBanner, setActionBanner] = useState(null);

    useEffect(() => {
        fetchData({ page: 1, pageSize: 10, resetPageSize: false });
    }, [activeSegment, partnerOnly, toInvoiceOnly]);

    const closeDropdown = (record) => {
        document.getElementById(`dropdown-klanten-action-${record?.id}`)?.removeAttribute("open");
    };

    const displayName = (row) => row?.klantId?.naam || row?.handelsNaam || "";

    const columns = [
        {
            title: "Naam Klant",
            // Partner-aanvragen hebben geen klantaccount: dan tonen we de
            // handelsnaam met een partner-badge. Sorter is null-safe.
            render: (record) => (
                <span className="inline-flex flex-wrap items-center gap-1.5">
                    <span>{record?.klantId?.naam || record?.handelsNaam || ""}</span>
                    <PartnerBadge row={record} />
                </span>
            ),
            sorter: (a, b) => displayName(a).localeCompare(displayName(b)),
        },
        {
            title: "KVK-Nummer",
            dataIndex: "KvkNummer",
            sorter: (a, b) => a.KvkNummer.localeCompare(b.KvkNummer),
        },
        {
            title: "Kenmerk",
            dataIndex: "Kenmerk",
            sorter: (a, b) => a.Kenmerk.localeCompare(b.Kenmerk),
        },
        {
            title: "Regeling",
            dataIndex: "regling",
            sorter: (a, b) => a.regling.localeCompare(b.regling),
        },
        {
            title: "Datum",
            dataIndex: "datumOpdrachtBevestiging",
            render: (text) => <span>{text}</span>,
            sorter: (a, b) => a.datumOpdrachtBevestiging - b.datumOpdrachtBevestiging,
        },
        {
            title: "Status",
            dataIndex: "status",
            sorter: (a, b) => a.status.localeCompare(b.status),
        },
        {
            title: "Action",
            render: (record) => (
                <Dropdown className="dropdown-action dropdown dropdown-end" id={"dropdown-klanten-action-" + record?.id}>
                    <summary className="inline-flex items-center mt-2 me-2 p-2 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50 ">
                        <FeatherIcon icon="more-vertical" />
                    </summary>
                    <ul className="dropdown-content z-[1] flex flex-col gap-1 w-fit">
                        <a onClick={() => { closeDropdown(record); handleViewClick(record) }}
                            className="link-ancher hover:bg-gray-100 hover:rounded-[10px] px-4 py-1">
                            View
                        </a>
                        {/* <a onClick={() => { closeDropdown(record) }} className="link-ancher hover:bg-gray-100 hover:rounded-[10px] px-4 py-1">
                            Bewerk
                        </a> */}
                    </ul>
                </Dropdown>
            ),
        },
    ];

    const fetchData = async ({ page, pageSize, resetPageSize }) => {
        try {
            setLoading(true);
            const response = await adminFetchAllApplications(page, pageSize, searchText, "EIA", activeSegment, { partner: partnerOnly, toInvoice: toInvoiceOnly });
            setStatistics({
                totalApplications: response.totalCount,
                totalAmount: response.totalAmount,
            });
            const result = {
                // Rijsleutel = _id: de selectie (bulk verwijderen, partner-factuur)
                // werkt op ids, niet op de positie in de pagina.
                data: response.docs.map((application) => ({ ...application, key: application._id })),
                totalDataCount: response.totalDocs,
                resetPageSize,
            };
            setData(result);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData({ page: 1, pageSize: 10, resetPageSize: false });
    }, [searchText]);

    const handleSearch = (query) => {
        setSearchText(query);
    };

    const handleDelete = async () => {
        Swal.fire({
            title: 'Weet je het zeker?',
            text: "Dit kan niet ongedaan worden gemaakt!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ja, verwijder het!',
            cancelButtonText: 'Annuleren'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    await adminDeleteApplication(SelectedRows);
                    fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                    setSeletedRows([]);
                    Swal.fire(
                        'Verwijderd!',
                        'De geselecteerde aanvragen zijn verwijderd.',
                        'success'
                    );
                } catch (error) {
                    console.error("Error deleting applications:", error);
                    Swal.fire(
                        'Mislukt!',
                        'Er is een fout opgetreden bij het verwijderen van de aanvragen.',
                        'error'
                    );
                }
            }
        });
    };

    const handleExport = () => {
        const csvData = data.data.map(row => ({
            ID: row._id,
            Naam: row.klantId?.naam || row.handelsNaam || '',
            Partner: row.partnerUserId?.bedrijfsnaam || row.partnerUserId?.naam || '',
            PartnerFactuurStatus: row.partnerInvoice?.status || '',
            KvkNummer: row.KvkNummer,
            VoorLetters: row.VoorLetters,
            Geslacht: row.geslacht,
            PostCode: row.postCode,
            StraatNaam: row.straatNaam,
            Email: row.email,
            Kenmerk: row.Kenmerk,
            MeldCodes: row?.meldCodes,
            HandelsNaam: row.handelsNaam,
            AchterNaam: row.achterNaam,
            HuisNummer: row.huisNummer,
            Plaats: row.plaats,
            TelefoonNummer: row.teleFoonNummer,
            DatumOpdrachtBevestiging: row.datumOpdrachtBevestiging,
            // TotaalVermogen: row.totaalVermogen, // this only available in eia-zon-overzicht
            // AantalZonnepanelen: row.aantalZonnepanelen, // this only available in eia-zon-overzicht
            // Type: row.type, // this only available in isde-overzicht
            Regeling: row.regling,
            Status: row.status,
            ExclusiveBTW: row.exclusiveBTW,
            InclusiveBTW: row.inclusiveBTW,
            Totaal: row.totaal
        }));
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "aanvragen.csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const RowChanges = (rows) => {
        setSeletedRows(rows)
        //  
        

    }

    // Knop "Maak partner-factuur": alleen als alle geselecteerde rijen
    // dezelfde partner delen en er minstens één goedgekeurde, nog niet
    // gefactureerde aanvraag tussen zit.
    const partnerInvoiceCandidate = useMemo(() => {
        if (!SelectedRows?.length) return null;
        const ids = new Set(SelectedRows.map(String));
        const rows = (data?.data ?? []).filter((r) => ids.has(String(r._id)));
        return partnerInvoiceCandidateFromRows(rows);
    }, [data, SelectedRows]);

    const formatNumber = (number) => {
        return number.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      
    return (
        <div className="page-wrapper">
            <div className="content admin-pages">
                <div className="py-4">
                    <div className="grid md:grid-cols-3 grid-cols-1 mt-5 md:gap-[30px]">
                        <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
                            <p className="title text-[16px]">EIA Aanvragen</p>
                            <div className="text-with-icon flex items-center gap-2 mt-3">
                                <div className="icon bg-[#E4F0FF]">
                                    <FeatherIcon icon="user" size="20" />
                                </div>
                                <p className="count text-[16px]">{statistics?.totalApplications}</p>
                            </div>
                        </div>

                        <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
                            <p className="title text-[15px]">Totaal Omzet</p>
                            <div className="text-with-icon flex items-center gap-2 mt-3">
                                <div className="icon financieel">
                                    <span>€</span>
                                </div>
                                  <p className="count text-[16px]">{formatNumber(statistics?.totalAmount || '0')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="my-10">
                    <SearchComponent onSearch={handleSearch} type={'applications'} />
                </div>
                <div className="table-responsive card p-4 bg-[#FAFBFE]">
                    <div className="bg-[#FAFBFE] px-0 py-3 flex justify-between items-center">
                        <div>
                            <button disabled={!SelectedRows?.length} className="btn animate-none me-2 bg-[#EB4747] bg-opacity-20 text-black border-none hover:bg-opacity-30 hover:bg-[#EB4747] px-4 shadow-none py-1 disabled:bg-opacity-30 disabled:opacity-50 disabled:text-black disabled:bg-[#EB4747]" onClick={handleDelete}>
                                <FeatherIcon
                                    icon="trash-2"
                                    className="h-5 text-[#EB4747]"
                                ></FeatherIcon>
                                Verwijder
                            </button>

                            <button disabled={!SelectedRows?.length} className="btn animate-none bg-[#DEF8EC] text-black border-none hover:bg-[#DEF8EC] px-4 shadow-none py-1  disabled:opacity-50 disabled:text-black disabled:bg-[#DEF8EC]" onClick={handleExport}>
                                <FeatherIcon
                                    icon="download"
                                    className="h-5 text-[#82A695]"
                                ></FeatherIcon>
                                Exporteer
                            </button>

                            {partnerInvoiceCandidate ? (
                                <button
                                    type="button"
                                    className="btn animate-none ms-2 bg-violet-100 text-violet-900 border-none hover:bg-violet-200 px-4 shadow-none py-1"
                                    onClick={() => setInvoiceBuilderOpen(true)}
                                    title={partnerInvoiceCandidate.blockedCount
                                        ? `${partnerInvoiceCandidate.blockedCount} geselecteerde aanvraag/aanvragen worden overgeslagen (niet goedgekeurd of al gefactureerd).`
                                        : `Factuur voor ${partnerInvoiceCandidate.partnerNaam}`}
                                >
                                    <FeatherIcon icon="file-text" className="h-5 text-violet-700" />
                                    Maak partner-factuur ({partnerInvoiceCandidate.eligibleIds.length})
                                </button>
                            ) : null}
                        </div>

                        <div className="flex flex-wrap items-center justify-center gap-4">
                            <label className="flex items-center gap-2 text-sm text-gray-700">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300"
                                    checked={partnerOnly}
                                    onChange={(e) => setPartnerOnly(e.target.checked)}
                                />
                                Alleen partner-aanvragen
                            </label>
                            <label className="flex items-center gap-2 text-sm text-gray-700">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300"
                                    checked={toInvoiceOnly}
                                    onChange={(e) => {
                                        setToInvoiceOnly(e.target.checked);
                                        // Te factureren = Goedgekeurd, dat valt onder OUD.
                                        if (e.target.checked) setActiveSegment('old');
                                    }}
                                />
                                Te factureren
                            </label>
                            <div className="inline-flex rounded-lg shadow h-[48px]">
                                <button
                                    className={`px-4  w-[105px] rounded-l-lg ${activeSegment === 'new' ? 'bg-[#DEF8EC] text-[#82A695]' : 'bg-gray-200 text-gray-700'}`}
                                    onClick={() => setActiveSegment('new')}
                                >
                                    Actief
                                </button>
                                <button
                                    className={`px-4 w-[105px] rounded-r-lg ${activeSegment === 'old' ? 'bg-[#DEF8EC] text-[#82A695]' : 'bg-gray-200 text-gray-700'}`}
                                    onClick={() => setActiveSegment('old')}
                                >
                                    OUD
                                </button>
                            </div>
                        </div>
                    </div>

                    {actionBanner ? (
                        <div className="mb-3 flex items-start justify-between gap-3 rounded-lg border border-emerald-300 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
                            <span>
                                {actionBanner.kind === "invoice_sent"
                                    ? `Partner-factuur ${actionBanner.invoiceNumber ?? ""} aangemaakt en verstuurd (${actionBanner.count} regel(s)).`
                                    : `Partner-factuur ${actionBanner.invoiceNumber ?? ""} aangemaakt als concept (${actionBanner.count} regel(s)).`}
                            </span>
                            <button type="button" className="text-xs underline" onClick={() => setActionBanner(null)}>Sluiten</button>
                        </div>
                    ) : null}

                    <div className="bg-white rounded-[20px]">
                        <Table
                            columns={columns}
                            response={data}
                            fetchData={fetchData}
                            SelectedRows={RowChanges}
                        />
                    </div>
                </div>
            </div>

            {invoiceBuilderOpen && partnerInvoiceCandidate ? (
                <PartnerInvoiceBuilderModal
                    isOpen={invoiceBuilderOpen}
                    onClose={() => setInvoiceBuilderOpen(false)}
                    applicationModel="Applications"
                    partnerUserId={partnerInvoiceCandidate.partnerUserId}
                    applicationIds={partnerInvoiceCandidate.eligibleIds}
                    onCreated={(invoice, { sent }) => {
                        setInvoiceBuilderOpen(false);
                        setSeletedRows([]);
                        setActionBanner({
                            kind: sent ? "invoice_sent" : "invoice_draft",
                            count: invoice?.lines?.length ?? 0,
                            invoiceNumber: invoice?.invoiceNumber,
                        });
                        fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                    }}
                />
            ) : null}
        </div>
    );
};

export default AdminEIAAanvragenPage;
